import { useState } from 'react';

import { useGetTaskTypes } from '../../api/getTaskTypes';
import { dictionaryTypes } from '../../types';
import { DictionaryList } from '../DictionaryList';

import { TaskTypesRow } from './TaskTypesRow';

export const TaskTypesList = () => {
  const [viewMode, setViewMode] = useState<dictionaryTypes.ViewMode>('active');
  const { data, isLoading, isFetching, isError, refetch } = useGetTaskTypes({ viewMode });
  const taskTypes = data?.taskTypes ?? [];

  return (
    <DictionaryList
      viewMode={viewMode}
      onViewModeChange={setViewMode}
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      onRetry={refetch}
      columnLabel="Task type"
      errorText="Failed to load task types"
      emptyText={viewMode === 'archived' ? 'No archived task types' : 'No task types'}
      isEmpty={taskTypes.length === 0}
    >
      {taskTypes.map((taskType) => (
        <TaskTypesRow key={taskType._id} taskType={taskType} />
      ))}
    </DictionaryList>
  );
};
